const record = (value) => value && typeof value === 'object' ? value : {};
const text = (value) => value == null ? '' : String(value).trim();
const dayNumber = (value) => /^\d+$/.test(text(value)) && Number(value) > 0 ? Number(value) : null;
const calendarDay = (value) => {
    const match = text(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T|\s)/);
    if (!match)
        return null;
    const [, year, month, day] = match.map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
        ? date.getTime() / 86400000 : null;
};
/** File rows refer to the group's first day, not necessarily the item's day. */
export function getTravelFileItemDay(item) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const group = record(item.travel_day);
    const firstDay = dayNumber((_c = (_b = (_a = item.travel_day_number) !== null && _a !== void 0 ? _a : item.day_number) !== null && _b !== void 0 ? _b : item.travelDayNumber) !== null && _c !== void 0 ? _c : group.day_number);
    const firstDate = calendarDay((_d = item.travel_day_date) !== null && _d !== void 0 ? _d : group.day_date);
    const params = Array.isArray(item.params) ? item.params.map(record) : [];
    const dateFor = (keys) => {
        var _a, _b, _c, _d, _e, _f;
        for (const key of keys) {
            const param = params.find(row => row.param_key === key);
            const value = calendarDay((_f = (_e = (_d = (_c = (_b = (_a = param === null || param === void 0 ? void 0 : param.value) !== null && _a !== void 0 ? _a : param === null || param === void 0 ? void 0 : param.param_value) !== null && _b !== void 0 ? _b : param === null || param === void 0 ? void 0 : param.field_value) !== null && _c !== void 0 ? _c : param === null || param === void 0 ? void 0 : param.value_text) !== null && _d !== void 0 ? _d : param === null || param === void 0 ? void 0 : param.value_str) !== null && _e !== void 0 ? _e : param === null || param === void 0 ? void 0 : param.value_date) !== null && _f !== void 0 ? _f : item[key]);
            if (value !== null)
                return value;
        }
        return null;
    };
    const start = dateFor(['depart_date', 'start_date', 'date_start', 'checkin_date', 'visit_date', 'when_date', 'date']);
    const finish = dateFor(['arrive_date', 'end_date', 'date_finish', 'checkout_date', 'finish_date']);
    const calculate = (date) => {
        if (date === null || firstDate === null || firstDay === null)
            return null;
        const result = firstDay + date - firstDate;
        return result > 0 ? result : null;
    };
    const from = (_j = (_g = (_f = dayNumber((_e = item.plan_day_number_start) !== null && _e !== void 0 ? _e : item.planDayNumberStart)) !== null && _f !== void 0 ? _f : calculate(start !== null && start !== void 0 ? start : finish)) !== null && _g !== void 0 ? _g : dayNumber((_h = item.plan_day_number) !== null && _h !== void 0 ? _h : item.planDayNumber)) !== null && _j !== void 0 ? _j : firstDay;
    const to = (_l = dayNumber((_k = item.plan_day_number_finish) !== null && _k !== void 0 ? _k : item.planDayNumberFinish)) !== null && _l !== void 0 ? _l : calculate(finish);
    const role = text((_m = item.range_role_name) !== null && _m !== void 0 ? _m : item.rangeRoleName);
    if (role === 'end' || role === 'finish')
        return text(to !== null && to !== void 0 ? to : from);
    if (role === 'start')
        return text(from);
    return from !== null && to !== null && to > from ? `${from}–${to}` : text(from);
}
